import { setMessageApi, setNotificationApi } from '@/utils/messageService';
import { App } from 'antd';
import { useEffect } from 'react';

export default function AppProvider({ children }) {
  const { message, notification } = App.useApp();

  useEffect(() => {
    setMessageApi(message);
  }, [message]);

  useEffect(() => {
    setNotificationApi(notification);
  }, [notification]);

  return children;
}
